/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon16Regular = forwardRef('ArrowDCornerDownLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.25 7c0 .69-.56 1.25-1.25 1.25H4.06l3.22-3.22a.75.75 0 1 0-1.06-1.06L2.568 7.62a1.95 1.95 0 0 0 0 2.758L6.22 14.03a.75.75 0 0 0 1.06-1.06L4.06 9.75H12A2.75 2.75 0 0 0 14.75 7V.75a.75.75 0 0 0-1.5 0V7Z" })));
});
